import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentWillMount() {
        window.addEventListener('resize', this.resize, true);
        window.addEventListener('keyup', this.keyup, true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize, true);
        window.removeEventListener('keyup', this.keyup, true);
    }

    render() {
        return (
            <light-box onClick={this.show} />
        );
    }

    show = () => {
        const lbb = document.createElement('div');
        lbb.classList.add('light-box-backdrop');
        lbb.addEventListener('click', this.remove, true);
        document.body.appendChild(lbb);

        const lbi = document.createElement('img');
        lbi.classList.add('light-box-image');
        lbi.setAttribute('src', this.props.src);
        lbi.addEventListener('click', this.remove, true);
        document.body.appendChild(lbi);

        this.setState({
            lbi: lbi,
            lbb: lbb,
        });

        this.resize();
    }

    resize = () => {
        const lbi = this.state.lbi;

        if (lbi) {
            lbi.style.top = `${((window.innerHeight - lbi.outerHeight()) / 2)}px`;
            lbi.style.left = `${((window.innerWidth - lbi.outerWidth()) / 2)}px`;
        }
    }

    keyup = (e) => {
        if (this.state.lbi && e.which == 27) {
            this.remove();
        }
    }

    remove = () => {
        document.body.removeChild(this.state.lbi);
        document.body.removeChild(this.state.lbb);

        this.setState({lbi: null, lbb: null});
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/light-box.js